//index.js
import Repository from "../../../repositories/RepositoryFactory";
const LoggedRepository = Repository.get("logged");
export default {
    async getStaff(context, payload) {
        var response = await LoggedRepository.getStaff(payload);
        context.commit("getStaff", response); //commit will call mutation name
    },
    // Fire and forget: the point is the request itself. If the session has been revoked the API
    // answers 401 and AxiosClient signs this browser out, so there is nothing to commit here.
    async checkSession() {
        await LoggedRepository.getCurrentSession();
    },
};
